import { getApp, getApps, initializeApp } from 'firebase/app'
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
} from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { adminFirebaseClientConfig, validateAdminFirebaseClientConfig } from './adminClientConfig'
import { getOrInitializeAuth } from './authSingleton'

const APP_NAME = 'suguide-admin'
const config = adminFirebaseClientConfig

export const adminFirebaseConfigError = validateAdminFirebaseClientConfig(config)
export const isAdminFirebaseConfigured = adminFirebaseConfigError === null
export const adminFirebaseApp = isAdminFirebaseConfigured
  ? (getApps().some(app => app.name === APP_NAME) ? getApp(APP_NAME) : initializeApp(config, APP_NAME))
  : null

export const adminAuth = getOrInitializeAuth(adminFirebaseApp, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
})

export const adminDb = adminFirebaseApp ? getFirestore(adminFirebaseApp) : null
export const adminStorage = adminFirebaseApp && config.storageBucket ? getStorage(adminFirebaseApp) : null
